import { api } from "@/lib/pookieApi";

const TOKEN_KEY = "pl_jwt";
const USER_KEY = "pl_user";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getStoredUser() {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setStoredUser(user) {
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  else localStorage.removeItem(USER_KEY);
}

// Axios interceptor — attach JWT to every request
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Auto-logout on 401 from /auth/me
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      const url = error?.config?.url || "";
      if (url.includes("/auth/me") || url.includes("/auth/my-cases")) {
        setToken(null);
        setStoredUser(null);
      }
    }
    return Promise.reject(error);
  }
);

export async function requestOtp(phone) {
  const { data } = await api.post("/auth/request-otp", { phone });
  return data;
}

export async function verifyOtp(phone, otp) {
  const { data } = await api.post("/auth/verify-otp", { phone, otp });
  setToken(data.token);
  setStoredUser(data.user);
  return data;
}

export async function fetchMe() {
  const { data } = await api.get("/auth/me");
  setStoredUser(data);
  return data;
}

export function signOut() {
  setToken(null);
  setStoredUser(null);
}
